module.exports = __webpack_public_path__ + "img/u167.483d6715.png";